
const PlayingEleven = (props) => {
    const {
        striker,
        nonStriker,
        onStartMatch,
        currentBowler,
        handleNonStrikerChange,
        handleStrikerChange,
        handleBowlerChange,
        battingTeamPlayers,
        bowlingTeamPlayers,
        canStartMatch
    } = props;

    // console.log(striker, 'striker');
    // console.log(nonStriker, 'nonStriker');
    // console.log(currentBowler, 'currentBowler');

    return (
        <div className="live-match-admin">
            <div className="live-header">
                <h3>Opening Player Setup</h3>
                <p>Select striker, non-striker, and bowler before live scoring</p>
            </div>

            <div className="match-setup">
                <h4>Match Setup</h4>

                <div className="team-selection d-flex justify-content-between flex-wrap gap-4">
                    <div className="team-list batting p-3 border rounded bg-dark text-light flex-fill">
                        <h5>{battingTeamPlayers[0]?.teamName || "Batting Team"}</h5>
                        <ul className="list-unstyled">
                            {battingTeamPlayers.map((item, i) => (
                                <li key={i}>
                                    ({i + 1}) {item.playerName} ({item.playerRole})
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="team-list bowling p-3 border rounded bg-dark text-light flex-fill">
                        <h5>{bowlingTeamPlayers[0]?.teamName || "Bowling Team"}</h5>
                        <ul className="list-unstyled">
                            {bowlingTeamPlayers.map((item, i) => (
                                <li key={i}>
                                    ({i + 1}) {item.playerName} ({item.playerRole})
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="opening-section mt-4">
                    <h5>Select Opening Players</h5>

                    <div className="openers d-flex gap-4 align-items-center">
                        <div className="opener-select">
                            <label>Striker:</label>
                            <select
                                value={striker?.playerName || ""}
                                onChange={handleStrikerChange}
                                className="form-select"
                            >
                                <option value="">Select Striker</option>
                                {battingTeamPlayers.map((item, i) => (
                                    <option key={i} value={item.playerName}>
                                        {item.playerName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="opener-select">
                            <label>Non-Striker:</label>
                            <select
                                value={nonStriker?.playerName || ""}
                                onChange={handleNonStrikerChange}
                                className="form-select"
                            >
                                <option value="">Select Non-Striker</option>
                                {battingTeamPlayers
                                    .filter((p) => p.playerName !== striker?.playerName)
                                    .map((item, i) => (
                                        <option key={i} value={item.playerName}>
                                            {item.playerName}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="opener-select">
                            <label>Bowler:</label>
                            <select
                                value={currentBowler?.playerName || ""}
                                onChange={handleBowlerChange}
                                className="form-select"
                            >
                                <option value="">Select Bowler</option>
                                {bowlingTeamPlayers.map((item, i) => (
                                    <option key={i} value={item.playerName}>
                                        {item.playerName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <button
                        onClick={() => onStartMatch(true)}
                        className="btn btn-success mt-4"
                        disabled={!canStartMatch}
                    >
                        Start Match
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PlayingEleven;
